export const TOGGLE_WIDGET_NAMES = {
  news: 'zprávy',
  video: 'video',
  woman: 'Ženu',
  sport: 'sport',
  finance: 'finance',
  mobileHousing: 'reality',
  exchange: 'kurzy',
  regional: 'regiony',
  leaflets: 'letáky',
  celebrities: 'celebrity',
  mobileBydleni: 'bydlení'
}
